import { HTMLProps, SetStateAction, Dispatch, useState, ChangeEvent, useEffect, useRef } from 'react';
import styled, { StyledComponent } from 'styled-components';
import styles from './Togglebox.module.css';

type Props = {
  isChecked: boolean;
  handleClick: (event: ChangeEvent<HTMLInputElement>) => void;
};

const ToggleBox = ({
  indeterminate,
  className = '',
  ...props
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) => {
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !props.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return <input className={styles['extended-togglebox']} type="checkbox" ref={ref} {...props} />;
};

export default ToggleBox;

const ToggleBoxContainer = styled.div`
  width: 40px;
  height: 24px;
  flex-shrink: 0;
`;

const StyledCheckbox: StyledComponent<
  'input',
  any,
  {
    type: 'checkbox';
  },
  'type'
> = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  position: relative;
  border: max(2px, 0.1em) solid #e2e4eb;
  border-radius: 1.25em;
  width: 40px;
  height: 24px;
  background-color: #e2e4eb;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    transform: scale(0.8);
    background-color: white;
    transition: left 250ms linear;
  }

  &:checked {
    background-color: #1c48cd;
    border-color: #1c48cd;
  }

  &:checked::before {
    background-color: white;
    left: 17px;
  }

  &:focus-visible {
    outline-offset: max(2px, 0.1em);
    outline: max(2px, 0.1em) solid tomato;
  }

  &:enabled:hover {
    ${({ theme, checked }) => ({
      boxShadow: `0 0 0 max(4px, 0.2em) ${checked ? '#1c48cd' : '#e2e4eb'}`,
    })}
  }
`;
